export default __webpack_public_path__ + "static/media/Brigand's Wristbands of the Covert Trail.298e1b8e.jpg";